import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18";
import "./index.css";
import "./styles/_core.scss";
import { ScrollContextProvider } from "./containers/scrollContextProvider/scrollContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollContextProvider>
      <App />
    </ScrollContextProvider>
  </BrowserRouter>
);
